module.exports = __webpack_public_path__ + "img/emoji_84.a5fb4ea0.png";